import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: ()=>import('@/views/index.vue')
  },
  {
    path: '/download',
    name: 'index',
    component: ()=>import('@/views/index.vue')
  },
  {
     path: '/notice/:id',
     name: 'notice',
     component: ()=>import('@/views/notice.vue')
  },
  {
    path: '/productIntro',
    name: 'productIntro',
    component: () => import('@/views/productIntro.vue')
  },
  {
    path: '/productItem',
    name: 'productItem',
    component: () => import('@/views/productItem.vue')
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: () => import('@/views/productDetail.vue')
  },
  {
    path: '/software',
    name: 'software',
    component: () => import('@/views/software.vue')
  },
  {
    path: '/lenovoid/callback',
    name: 'software',
    component: () => import('@/views/lenovoCallback.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
